import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

if (typeof window !== `undefined`) {
  // because of SSR
  const L = require('leaflet')
  // BUG https://github.com/Leaflet/Leaflet/issues/4968
  const iconRetinaUrl = require('leaflet/dist/images/marker-icon-2x.png')
  const iconUrl = require('leaflet/dist/images/marker-icon.png')
  const shadowUrl = require('leaflet/dist/images/marker-shadow.png')
  L.Marker.prototype.options.icon = L.icon({
    iconRetinaUrl,
    iconUrl,
    shadowUrl,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41]
  })
}
import stateBoundaries from "./state.boundaries.json"
import countyBoundaries from "./county.boundaries.json"
import cityBoundaries from "./city.boundaries.json"

export const data = {
  title: 'Code Map',
  layoutType: 'calc',
  path: '/code-map/'
}

class CodeMap extends React.Component {
  componentDidMount() {
    var map = this.map = L.map('mapid').setView([39.7, -97.5], 4);

    L.tileLayer( 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      subdomains: ['a','b','c']
    }).addTo(map);

    var popup = map.popup = L.popup();

    let onEachFeature = (feature, layer) => {
      layer.on({
          mouseover: this.highlightFeature,
          mouseout: this.resetHighlight,
          click: this.onGeojsonClick
      });
    }
  
    var gjState = this.geojson = L.geoJSON(stateBoundaries, {
        style: function(feature) {return shadeFeature(feature)},
        onEachFeature: onEachFeature
    }).addTo(map);

    var gjCounty = this.geojson = L.geoJSON(countyBoundaries, {
        style: function(feature) {return shadeFeature(feature)},
        onEachFeature: onEachFeature
    }).addTo(map);

    var gjCity = this.geojson = L.geoJSON(cityBoundaries, {
        style: function(feature) {return shadeFeature(feature)},
        onEachFeature: onEachFeature
    }).addTo(map);
  }

  highlightFeature(e) {
    let layer = e.target;

    layer.setStyle({
      weight: 2,
      fillOpacity: 0.2
    });
  }

  resetHighlight(e) {
    //TODO, redo to geojson.resetStyle(e.target)
    let layer = e.target;

    layer.setStyle({
      weight: 0,
      fillOpacity: 0.5
    });
  }

  onGeojsonClick(event) {
    console.log(this)
    console.log(event)
    let prop = event.target.feature.properties
    let popcontent = `
      <h4></strong>${prop.name}</strong></h4><br/>
      <span><strong>Building Code:</strong> ${prop.building_code.ibcyear} IBC ${prop.building_code.amended === "yes" ? 'Amended' : ''}</span><br/>
      <span><strong>Loads:</strong></span><br/>
      <span>&nbsp;<strong>Category I:</strong></span><br/>
      <span>&nbsp;&nbsp;Wind: ${prop.building_code.loads.wind.catI.velocity} mph</span><br/>
      <span>&nbsp;<strong>Category II:</strong></span><br/>
      <span>&nbsp;&nbsp;Wind: ${prop.building_code.loads.wind.catII.velocity} mph</span><br/>
      <span>&nbsp;<strong>Category III:</strong></span><br/>
      <span>&nbsp;&nbsp;Wind: ${prop.building_code.loads.wind.catIII.velocity} mph</span><br/>
      <span>&nbsp;<strong>Category IV:</strong></span><br/>
      <span>&nbsp;&nbsp;Wind: ${prop.building_code.loads.wind.catIV.velocity} mph</span><br/>
      <span>Notes: ${prop.building_code.notes ? prop.building_code.notes : "None"}</span><br/>
      <a href="${prop.building_code.reference}" target="_blank">Code Source</a><br/><br/>
      <span>Latitude: ${event.latlng.lat}</span><br/>
      <span>Longtitude: ${event.latlng.lng}</span>
    `;
    this._map.popup
      .setLatLng(event.latlng)
      .setContent(popcontent)
      .openOn(this._map);
  }

  zoomTo(event) {
    this.map.setView([this.latlngform.lat.value, this.latlngform.long.value], 20)
    this.latlngform.lat.value = "";
    this.latlngform.long.value = "";
    event.preventDefault();
  }

  componentWillUnmount() {
    this.map.off('click', this.onGeojsonClick);
    this.map = null;
  }

  render() {
    this.latlngform = {}

    return (
        <div>
          <div id="mapid" style={{height: '800px'}}></div>
          <div className="box">
            <div className="content">
              <h2 className="subtitle">Enter a project location</h2>
              <p>Click on any of the colored areas of the map to see relevant information regarding the IBC version that state or municipality uses.</p>
            </div>
            <form className="">
              <div className="field">
                <label className="label">Latitude:</label>
                <div className="control">
                  <input className="input" type="number" step="0.000001" ref={(lat) => this.latlngform.lat = lat} />
                </div>
              </div>
              <div className="field">
                <label className="label">Longitude:</label>
                <div className="control">
                  <input className="input" type="number" step="0.000001" ref={(long) => this.latlngform.long = long} />
                </div>
              </div>
              <div className="field">
                <div className="control">
                  <button className="button is-link" onClick={this.zoomTo.bind(this)}>Zoom</button>
                </div>
              </div>
            </form>
          </div>
        </div>
    )
  }
}

export default CodeMap

var shadeFeature = (feature) => {
        let returnStyle = {
          weight: "0",
          fillOpacity: "0.5"
        }
        if(feature.geometry.type === "Polygon" || feature.geometry.type === "MultiPolygon") {
            returnStyle = {...returnStyle, ...geoFill(feature.properties.building_code.ibcyear)}
        }
        return returnStyle
}

let geoFill = (ibcyear) => {
  switch (ibcyear) {
    case '2003': return {color: "#ffff00"};
    case '2006': return {color: "#ffa500"};
    case '2009': return {color: "#165c16"};
    case '2012': return {color: "#0000ff"};
    case '2015': return {color: "#2f165c"};
    default: return {color: "#ff0000"};
  }
}


// WEBPACK FOOTER //
// ./src/main/code-map/index.js